module.exports = __webpack_public_path__ + "img/Weapon_magic_01_mesh.15dddbbb.png";